export enum AndroidBackPriority {
    COMPONENT = 9999,
    OVERLAY = 10002,
    DASHBOARD = 10001,
    DIALOG = 10003
}